import { WpPayment} from './wp-payment.model';
import { WpPayee} from './wp-payee.model';
import { WpVendor} from './wp-vendor.model';

export class RequestPayment {
  constructor(
      public id?: number,
      public wpActivityList?: any,
      public wpPayment?: WpPayment,
      public selectedWpActivity?: any,
      public personId?: number,
      public referralId?: number,
      public paymentId?: number,
      public wpPayee?:WpPayee,
      public wpVendor?:WpVendor,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/request-payment.model.ts